import React, { useEffect, useState } from 'react';
import './ModulesMenu.css';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import UserRoles from '../../../constants/userRoles';

// Constants
const moduleNames = {
  CodeMapping: 'Code Mapping',
  RulesConfiguration: 'Rules Configuration',
  TeamAlerts: 'Team Alerts',
  AdminManagement: 'Admin Management',
  Administration: 'Administration',
  Reporting: 'Reporting'
}

const menus = [
  {
    name: moduleNames.CodeMapping,
    description: '',
    uri: '/CodeMapping',
    active: false,
    items: [],
  },
  {
    name: moduleNames.RulesConfiguration,
    description: '',
    uri: '/RulesConfiguration',
    items: [],
  },
  {
    name: moduleNames.TeamAlerts,
    description: '',
    uri: '/TeamAlerts',
    active: true,
    items: [],
  },
  {
    name: moduleNames.AdminManagement,
    active: false,
    description: '',
    uri: '/AdminManagement',
    items: [],
  },
  {
    name: moduleNames.Administration,
    active: false,
    description: '',
    uri: '/Administration',
    items: [],
  },
  {
    name: moduleNames.Reporting,
    active: false,
    description: 'Reporting',
    uri: '/Reporting',
    items: [],
  }
];

const ModulesMenu = () => {
  const user = useSelector((state) => state.User);
  const [activeTab, setActiveTab] = useState('');
  const location = useLocation();

  const handleModuleClick = (moduleName) => {
    sessionStorage.setItem('selectedModule', moduleName);
    setActiveTab(moduleName);
  }

  useEffect(() => {
    const storedSelectedOption = sessionStorage.getItem('selectedModule');

    if (location.pathname === storedSelectedOption) {
      setActiveTab(storedSelectedOption);
    }
    else {
      setActiveTab('');
    }
  }, [location]);

  return (
    <header className='siteHeader'>
      <div className='siteHeader__row'>
        <div className='siteHeader__wrapper'>
          <div className='siteHeader__nav-group'>
            <nav className='horizontalNavigation'>
              <ul className='horizontalNavigation__list' style={{ cursor: 'hand !important' }}>
                {
                  menus.map((elem) => {
                    if (user.Role !== UserRoles.Admin && user.Role !== UserRoles.Owner) {
                      if (elem.name === moduleNames.AdminManagement || elem.name === moduleNames.Reporting) {
                        return null;
                      }

                      if (user.Role === UserRoles.WFM) {
                        if (elem.name === moduleNames.CodeMapping) {
                          if (!(user.Claims.CodeMappingEnterpriseSearch) && !(user.Claims.CodeMappingEnterpriseCreate)) {
                            return null;
                          }
                        }
                        else if (elem.name === moduleNames.RulesConfiguration) {
                          if (!(user.Claims.RulesConfigurationEnterpriseCreate) && !(user.Claims.RulesConfigurationEnterpriseSearch)
                          && !(user.Claims.RulesConfigurationCustomCreate) && !(user.Claims.RulesConfigurationCustomSearch)) {
                            return null;
                          }
                        }
                      }
                      else if (user.Role === UserRoles['G&A']) {
                          if (elem.name !== moduleNames.TeamAlerts) {
                            return null;
                        }
                      }
                      else {
                        return null;
                      }
                    }
                    if (elem.name === moduleNames.Administration && user.Role !== UserRoles.Owner) {
                      return null;
                    }
                    return (
                      <Link style={{ cursor: 'hand !important' }} key={`${elem.name}`} to={elem.uri} onClick={(event) => handleModuleClick(elem.uri, event)}>
                        <li style={{ cursor: 'hand !important' }} className='horizontalNavigation__list-item'>
                          <button
                            type='button'
                            style={{ cursor: 'hand !important' }}
                            data-nav-dropdown={`navigation__dropdown-${elem.name.replace(/ /g, '')}`}
                            aria-controls={`navigation__dropdown-${elem.name.replace(/ /g, '')}`}
                            aria-haspopup='true'
                            aria-expanded='false'
                            role='menuitem'
                            className={`navigation__link navigation__link-toggle ${activeTab === elem.uri ? 'activeTab' : ''}`}
                          >
                            <span className='navigation__link-text navigation__link-text-custom'>
                              {elem.name}
                            </span>
                          </button>
                          <div className='navigation__dropdown' id={`navigation__dropdown-${elem.name.replace(/ /g, '')}`}>
                            {
                              elem.active
                              && (
                              <div className='navigation__dropdown__section-list'>
                                <div className='navigation__dropdown__section'>
                                  <div className='navigation__dropdown__column-wrapper' />
                                </div>
                              </div>
                              )
                            }
                          </div>
                        </li>
                      </Link>
                    )
                  }
                  )
                }
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <div className='navigation__dropdown__wrapper'>
        <div className='navigation__dropdown__footer' />
        <div className='navigation__dropdown__featured-background' />
      </div>
    </header>
  );
};

export default ModulesMenu;
